var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCircledGreenCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 26,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 13,
  r: 12,
  fill: "#00BAC6"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m7.5 13.59 2.947 3.077L16.833 10",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgCircledGreenCheck as ReactComponent };
export default __webpack_public_path__ + "96e862f0906c640b3d4f354faae60654.svg";